<template>
    <el-dialog
      v-dialog-drag="{ draggable }"
      v-bind="attrs"
      v-on="$listeners"
      custom-class="tb-dialog-content"
    >
      <!-- 头部 -->
      <template slot="title" v-if="$slots['title']">
        <slot name="title"></slot>
      </template>
      <!-- 内容 -->
      <slot />
      <!-- 底部 -->
      <div
        v-if="isShowSure || isShowCancel"
        slot="footer"
        class="tb-dialog-footer"
      >
        <slot name="footer">
          <dy-button
            :loading="sureLoading"
            :disabled="sureDisable"
            v-if="isShowSure"
            type="blue"
            @click="comfirm"
            >{{ sureText }}</dy-button
          >
          <dy-button v-if="isShowCancel" @click="close">{{
            cancelText
          }}</dy-button>
        </slot>
      </div>
    </el-dialog>
</template>
<script>
export default {
  name: "TDialog",
  props: {
    // 是否开启拖拽功能(flase开启，true是关闭)
    draggable: {
      type: Boolean,
      default: false,
    },
    // 是否开启ESC关闭弹窗
    isESC: {
      type: Boolean,
      default: false,
    },
    // 是否显示确认按钮
    isShowSure: {
      type: Boolean,
      default: true,
    },
    // 确认按钮文案
    sureText: {
      type: String,
      default: "确定",
    },
    // 是否显示取消按钮
    isShowCancel: {
      type: Boolean,
      default: true,
    },
    // 取消按钮文案
    cancelText: {
      type: String,
      default: "取消",
    },
    // 确认按钮禁用
    sureDisable: {
      type: Boolean,
      default: false,
    },
    // 确认按钮加载
    sureLoading: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    attrs() {
      return {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        ...this.$attrs,
      };
    },
  },
  directives: {
    dialogDrag: {
      bind(el, binding, vnode) {
        if (!binding.value.draggable) return;
        const dialogHeaderEl = el.querySelector(".el-dialog__header");
        const dragDom = el.querySelector(".el-dialog");
        dialogHeaderEl.style.cssText += ";cursor:move;";
        dragDom.style.cssText += ";top:0px;";

        // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
        const getStyle = (function () {
          if (window.document.currentStyle) {
            return (dom, attr) => dom.currentStyle[attr];
          } else {
            return (dom, attr) => getComputedStyle(dom, false)[attr];
          }
        })();

        dialogHeaderEl.onmousedown = (e) => {
          // 鼠标按下，计算当前元素距离可视区的距离
          const disX = e.clientX - dialogHeaderEl.offsetLeft;
          const disY = e.clientY - dialogHeaderEl.offsetTop;

          const dragDomWidth = dragDom.offsetWidth;
          const dragDomHeight = dragDom.offsetHeight;

          const screenWidth = document.body.clientWidth;
          const screenHeight = document.body.clientHeight;

          const minDragDomLeft = dragDom.offsetLeft;
          const maxDragDomLeft =
            screenWidth - dragDom.offsetLeft - dragDomWidth;

          const minDragDomTop = dragDom.offsetTop;
          const maxDragDomTop =
            screenHeight - dragDom.offsetTop - dragDomHeight;

          // 获取到的值带px 正则匹配替换
          let styL = getStyle(dragDom, "left");
          let styT = getStyle(dragDom, "top");

          if (styL.includes("%")) {
            // eslint-disable-next-line no-useless-escape
            styL =
              +document.body.clientWidth * (+styL.replace(/\%/g, "") / 100);
            // eslint-disable-next-line no-useless-escape
            styT =
              +document.body.clientHeight * (+styT.replace(/\%/g, "") / 100);
          } else {
            styL = +styL.replace(/\px/g, "");
            styT = +styT.replace(/\px/g, "");
          }

          document.onmousemove = function (e) {
            // 通过事件委托，计算移动的距离
            let left = e.clientX - disX;
            let top = e.clientY - disY;
            // 边界处理
            if (-left > minDragDomLeft) {
              left = -minDragDomLeft;
            } else if (left > maxDragDomLeft) {
              left = maxDragDomLeft;
            }

            if (-top > minDragDomTop) {
              top = -minDragDomTop;
            } else if (top > maxDragDomTop) {
              top = maxDragDomTop;
            }

            // 移动当前元素
            dragDom.style.cssText += `;left:${left + styL}px;top:${
              top + styT
            }px;`;

            // emit onDrag event
            vnode.child.$emit("dragDialog");
          };

          document.onmouseup = function (e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
  },
  mounted() {
    this.keydownEvent();
    console.log(this.$slots)
  },
  methods: {
    keydownEvent() {
      if (!this.isESC) return;
      document.addEventListener("keydown", this.ESCEvent);
    },
    ESCEvent(e) {
      if (this.$attrs.visible && e.keyCode == 27) {
        console.log("e.keyCode", e.keyCode);
        this.$emit("update:visible");
      }
    },
    comfirm() {
      this.$emit("comfirm");
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss">
.tb-dialog-footer{
  height: 100%;
}
  .tb-dialog-content {
    border-radius: 4px !important;
    overflow: hidden;
    .el-dialog__header {
      border-bottom: 1px solid #f2f2f2;
      background-color: #fff;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 48px;
      line-height: 48px;
      .el-dialog__title {
        font-size: 14px;
        width: 100% !important;
      }
      .el-dialog__headerbtn {
        position: static;
        .el-dialog__close {
          font-size: 20px;
        }
      }
    }
    .el-dialog__body {
      overflow-y: auto;
      max-height: 720px;
      padding: 24px 24px 30px;
    }
    .el-dialog__footer {
      // height: 50px;
      padding: 10px 24px;
      border-top: 1px solid #f5f5f7;
    }
  }
</style>